import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/vansterpartiet.se/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

import { css, jsx } from "@emotion/react";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as defaultStyles from "./Icon.module.css";
import { useIconContext } from "./IconProvider";
import withComponentDefaults from "../utils/withComponentDefaults";
export default withComponentDefaults(Icon, "icon");

function Icon(_a) {
  var _b = _a,
      children = _b.children,
      className = _b.className,
      color = _b.color,
      name = _b.name,
      src = _b.src,
      _b$styles = _b.styles,
      styles = _b$styles === void 0 ? defaultStyles : _b$styles,
      size = _b.size,
      restProps = __objRest(_b, ["children", "className", "color", "name", "src", "styles", "size"]);

  void 0;

  var _useIconContext = useIconContext(),
      getIconSrc = _useIconContext.getIconSrc;

  if (name) {
    src = getIconSrc(name);
  }

  if (!src) {
    if (true) {
      if (name) {
        console.warn("Could not find any icon by the name \"".concat(name, "\". Did you wrap your app in an <IconProvider> and pass a \"getIconSrc\" prop?"));
      } else {
        console.warn("No \"src\" or \"name\" prop provided to <Icon> component.");
      }
    }
  }

  return /* @__PURE__ */jsx("span", __spreadValues({
    className: clsx(styles.component, className),
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        --icon-color: ", ";\n        --icon-size: ", ";\n        mask-image: url(", ");\n      "])), color, size, src)
  }, restProps));
}

Icon.propTypes = {
  children: PropTypes.oneOf([null, void 0, "", false]),
  className: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string,
  src: PropTypes.string,
  styles: PropTypes.objectOf(PropTypes.string),
  size: PropTypes.string
};